import type { RootState } from '@/store/root-reducer';

const selectState = (state: RootState) => state.exitsInvestmentsReview;

export const selectProfiles = (state: RootState) => selectState(state).profiles;
export const selectLoadStatus = (state: RootState) => selectState(state).loadStatus;
/** The "Exit & Investment Review" sidebar badge (#762); `null` until first read. */
export const selectToCompleteCount = (state: RootState) => selectState(state).toCompleteCount;
